module.exports = __webpack_public_path__ + "static/media/icon-calendar.2da0314c.svg";